import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateRecipientCrypto = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_20154_58694)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: .833984,
				y: .5,
				width: 24,
				height: 24,
				fill: "#EF4444"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .833984,
				y: .5,
				width: 24,
				height: 24,
				fill: "#EF4444"
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_20154_58694)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M12.834 7.0625V18.1263",
						stroke: "white",
						strokeWidth: .906885,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M17.4826 12.5605L12.8337 14.7671L8.19531 12.5809",
						stroke: "white",
						strokeWidth: .906885,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M12.3582 6.7574C12.6002 6.44932 13.0669 6.44932 13.309 6.7574L17.5279 12.127C17.7002 12.3462 17.7002 12.6548 17.5279 12.8741L13.309 18.2437C13.0669 18.5518 12.6002 18.5518 12.3582 18.2437L8.13919 12.8741C7.96694 12.6548 7.96694 12.3462 8.13919 12.127L12.3582 6.7574Z",
						stroke: "white",
						strokeWidth: .906885,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_20154_58694",
		children: /* @__PURE__ */ _jsx("rect", {
			x: .833984,
			y: .5,
			width: 24,
			height: 24,
			rx: 7.25508,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_20154_58694",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14.5102,
			height: 14.5102,
			fill: "white",
			transform: "translate(5.57812 5.24414)"
		})
	})] })]
});
export default SvgCreateRecipientCrypto;
